import { useState } from "react";

import AirlineSeatLegroomNormalIcon from "@mui/icons-material/AirlineSeatLegroomNormal";
import { Button, IconButton, Link } from "@mui/material";

import { useGlobalStoreContext } from "@/context/globalStoreContext";
import { FlightItem } from "@/typings";

import ProChip from "../ProChip";
import SitemapDialog from "./SitemapDialog";
import "./styles.css";

function SitemapDialogBtn(props: { data: FlightItem; type?: "icon" | "text"; isMobile?: boolean }) {
  const { data, type = "text", isMobile = false } = props;

  const [open, setOpen] = useState(false);

  const store = useGlobalStoreContext();

  const isPro = String(store.user_type) === "1";

  return (
    <>
      {type === "icon" ? (
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            if (isPro) {
              setOpen(true);
            } else {
              window.open("/pro", "_blank");
            }
          }}
        >
          <AirlineSeatLegroomNormalIcon className="!text-[18px]" />
        </IconButton>
      ) : (
        <div>
          <Link
            component={Button}
            underline="none"
            className={!isPro ? "!text-[14px] !font-medium" : "!text-[14px]"}
            onClick={(e) => {
              e.stopPropagation();

              if (isPro) {
                setOpen(true);
              } else {
                window.open("/pro", "_blank");
              }
            }}
            sx={{ borderRadius: "10px" }}
          >
            {isMobile ? "Seat map" : "Live seat map"}
            {!isPro && <ProChip height={"20px"} width={"42px"} openPage={false} />}
          </Link>
        </div>
      )}

      {open && <SitemapDialog data={data} open={open} onClose={() => setOpen(false)} />}
    </>
  );
}

export default SitemapDialogBtn;
